import { render, staticRenderFns } from "./EventSkeleton.vue?vue&type=template&id=ef18e710&scoped=true&"
import script from "./EventSkeleton.vue?vue&type=script&lang=ts&"
export * from "./EventSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./EventSkeleton.vue?vue&type=style&index=0&id=ef18e710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18e710",
  null
  
)

export default component.exports